import React from 'react'
import { connect } from 'dva'
import { bindActionCreators } from 'redux'

import { parameterCodes } from 'data/parameters'
import possibleOutcomes from 'data/outcomes'

import * as questionActions from 'models/question/actions'
import * as scoreActions from 'models/score/actions'
import * as appActions from 'models/app/actions'
import scoreSelectors from 'models/score/selectors'

import Outcome from './Outcome'

function getOutcomeText(score) {
  const currentPopularity = score.find(p => p.code === parameterCodes.popularity)
  //eslint-disable-next-line
  const popularity = currentPopularity.score
  const currentProfitability = score.find(p => p.code === parameterCodes.profitability)
  //eslint-disable-next-line
  const profitability = currentProfitability.score

  const outcome = possibleOutcomes.find(po => {
    const [popularityCondition, profitabilityCondition] = po.conditions

    //eslint-disable-next-line
    return eval(popularityCondition) && eval(profitabilityCondition)
  })

 return outcome ? outcome : {
    title: 'Пациент скорее жив, чем мёртв.',
    text: 'У тебя точно что-то получилось, но до вершин ещё ох как далеко. Попробуй, у тебя есть шансы.',
   }
}

class OutcomeContainer extends React.Component {
  constructor(props) {
    super(props)

    window.ga('send', 'event', 'Показы', 'Экран', 'Финальный экран_Издатель')
  }

  render() {
    const { score, actions } = this.props

    const outcome = getOutcomeText(score)
    const reset = () => {
      actions.question.reset()
      actions.score.reset()
      actions.app.reset()
    }

    return <Outcome outcome={outcome} reset={reset} />
  }
}

function mapStateToProps(state, ownProps) {
  return Object.assign({},
    scoreSelectors(state, ownProps),
  )
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      question: bindActionCreators(questionActions, dispatch),
      score: bindActionCreators(scoreActions, dispatch),
      app: bindActionCreators(appActions, dispatch),
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OutcomeContainer)



// WEBPACK FOOTER //
// ./src/components/Outcome/index.js